import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

interface NullStateMessageProps {
  children: ReactNode;
}

export const NullStateMessage = ({ children }: NullStateMessageProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        flexDirection: "column",
        backgroundColor: "action.hover",
        gap: 2,
      }}
    >
      <Typography>{children}</Typography>
    </Box>
  );
};
